import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { temp as tempActions, order, data as dataActions } from "actions";
import { ReduxStates } from "Types";
import { Data as DataType, Payment as PaymentType } from "Types/Reducers";
import { statuses } from "api";
import { payment as paymentStatuses } from "globalConstants";

import TemplateStep5 from "Components/Templates/Step5";

export default function PageStep5() {
   console.log("step 5");
   const dispatch = useDispatch();
   const payment = useSelector((state: { [key in keyof ReduxStates]: PaymentType }) => state.payment.type);
   const data = useSelector((state: any) => state.data);
   const orderTemp = useSelector((state: any) => state.order.temp);
   
   const orderClone = useSelector((state: any) => state.temp.orderClone);

   const syncTemp = useSelector((state: any) => state.temp.sync);
   const stateSet = useSelector((state: any) => state.temp.set);
   const navigate = useNavigate();
   const paymethod = payment === paymentStatuses.phone ? "hp" : payment === paymentStatuses.card ? "card" : "wp";

   function onSuccess() {
      
      if (payment === paymentStatuses.withoutPassbook && data.acount_holder === "") {
         Swal.fire({
            icon: "error",
            title: "입금자 명을 입력해주세요",
         });
         return;
      }

      dispatch({
         type: dataActions.set,
         payload: {
            ...data,
            temp_autoBackup: false,
         },
      });

      dispatch({
         type: order.temp.call,
         payload: {
            ...data,
            paymethod,
         },
      });
   }


   if (stateSet.status === statuses.resolved) {
      dispatch({
         type: dataActions.set,
         payload: {
            ...data,
            temp_exhibition_idx: parseInt(stateSet.data),
         },
      });
      dispatch({
         type: tempActions.sync.call,
         payload: {
            ...data,
            temp_exhibition_idx: parseInt(stateSet.data),
         },
      });

      dispatch({
         type: tempActions.set.reset,
      });
   }

   
         
   console.log("orderClone.status", orderClone.status);

   if (orderClone.status === statuses.resolved) {
      dispatch({
         type: tempActions.orderClone.reset,
      });
      navigate("/success");
   }

   

   if (orderTemp.status === statuses.resolved) {
      const orderCode = orderTemp.data.trim();
      dispatch({
         type: dataActions.set,
         payload: {
            ...data,
            order_code: orderCode,
         },
      });

      dispatch({
         type: tempActions.set.call,
         payload: {
            ...data,
         },
      });

      dispatch({
         type: order.temp.reset,
      });
   }

   if (syncTemp.status === statuses.resolved) {
      dispatch({
         type: dataActions.set,
         payload: {
            ...data,
            exhibition_id: syncTemp.data,
         },
      });

      if (payment === paymentStatuses.withoutPassbook) {
         dispatch({
            type: tempActions.orderClone.call,
            payload: {
               order_code: data.order_code,
               temp_exhibition_idx: data.temp_exhibition_idx,
            },
         });

         
      } else {
         const paymentWindow = window.open(
            "/order/payreq_crossplatform_estimate_exhibition.php?order_code=" + data.order_code + "&ptype=" + paymethod,
            "_blank",
            "width=650px,height=650px,scrollbars=no,location=no"
         );

         paymentWindow?.addEventListener("beforeunload", function (ev) {
            console.log("beforeunload", ev);
         });
      }


      dispatch({
         type: tempActions.sync.reset,
      });
   }

   useEffect(() => {
      dispatch({
         type: dataActions.set,
         payload: {
            ...data,
            temp_autoBackup: false,
         },
      });
      return () => {};
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
   return (
      <>
         <TemplateStep5 succeessOnClick={onSuccess}></TemplateStep5>
      </>
   );
}
